import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
        const ThankYou = () => import(/* webpackChunkName: "snippet-items-thank-you" */ 'components/SnippetTemplate/Items/ThankYou')
        new Vue({
            el: "#" + this.elemId,
            store,
            render: h => h(ThankYou, {props: eval(this.elemId)})
        })
    }
}
